// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3l1lt","Open":"SideDrawer_Open__1_2wv","Close":"SideDrawer_Close__2cgih","Logo":"SideDrawer_Logo__m9NnZ"};